import { Box } from '@mui/material'
import React from 'react'

export default function Centered({ children }) {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            {children}
        </Box>
    )
}
